"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

const EXCLUDED_PATHS = new Set(["/faqs"]);

export default function KisoScript() {
  const pathname = usePathname();

  if (EXCLUDED_PATHS.has(pathname)) {
    return null;
  }

  return (
    <Script
      src="https://tag.kisohq.com/v1/tag.js?orgId=5d98330e-fd9c-4809-8743-7fad3221c8cb"
      data-proxy="t.thiscar.com"
      strategy="afterInteractive"
    />
  );
}
